<template>
  <div class="timer-container">
      <div class="icon">
          <a-icon 
            type="lock"
          />
      </div>
      <div class="time"
      >
        <span
            class="time-text"
        >
            {{ clockString }}
        </span>
      </div>
  </div>
</template>

<script>
import { START_TIMER, STOP_TIMER } from '../../../store/action_types';


export default {

    computed: {
        clockString() {
            return this.$store.getters.getCurrentSessionClockFormat;
        }
    },



    methods: {
        resetClock() {
            this.$store.dispatch({
                type: STOP_TIMER
            })
        },
        restartTimer() {
            this.$store.dispatch({
                type: START_TIMER
            })
        }
    },
}
</script>

<style lang="scss" scoped>
    .timer-container {
        display: flex;
        color: white;
        .icon {
            margin-left: 5px;
            margin-right: 5px;
        }
    }
</style>